import React from 'react';
import ___SettingsActivitiesUsersActives from "./general/___SettingsActivitiesUsersActives";

const __SettingActivitiesGeneral = () => {

    return (<>
            <div className={"row"}>
                <div className={"col-md-6 col-sm-12"}>
                    <___SettingsActivitiesUsersActives/>
                </div>
            </div>
        </>
    );
};

export default __SettingActivitiesGeneral;
